import { render, staticRenderFns } from "./seltos-videopicstext-zhijia.vue?vue&type=template&id=3140312e"
import script from "./seltos-videopicstext-zhijia.vue?vue&type=script&lang=js"
export * from "./seltos-videopicstext-zhijia.vue?vue&type=script&lang=js"
import style0 from "./seltos-videopicstext-zhijia.vue?vue&type=style&index=0&id=3140312e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports